/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetTikTokCreatorInfoQueryResponse, GetTikTokCreatorInfoPathParams } from "../models/GetTikTokCreatorInfo";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getTikTokCreatorInfo } from "../axios/getTikTokCreatorInfo";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTikTokCreatorInfoQueryKey = (station: GetTikTokCreatorInfoPathParams["station"]) => ["social-export-api", { url: '/tiktok/:station/creator-info', params: {station:station} }] as const

export type GetTikTokCreatorInfoQueryKey = ReturnType<typeof getTikTokCreatorInfoQueryKey>

export function getTikTokCreatorInfoQueryOptions(station: GetTikTokCreatorInfoPathParams["station"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getTikTokCreatorInfoQueryKey(station)
        return queryOptions<GetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<Error>, GetTikTokCreatorInfoQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getTikTokCreatorInfo(station, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns TikTok creator profile and permission info (privacy options, comment/duet/stitch settings, max video duration). Use when rendering the Post to TikTok page per Content Sharing Guidelines.
 * @summary Get TikTok creator info for a station
 * {@link /tiktok/:station/creator-info}
 */
export function useGetTikTokCreatorInfo<TData = GetTikTokCreatorInfoQueryResponse, TQueryData = GetTikTokCreatorInfoQueryResponse, TQueryKey extends QueryKey = GetTikTokCreatorInfoQueryKey>(station: GetTikTokCreatorInfoPathParams["station"], options: 
{
  query?: Partial<QueryObserverOptions<GetTikTokCreatorInfoQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getTikTokCreatorInfoQueryKey(station)
         

         const query = useQuery({
          ...getTikTokCreatorInfoQueryOptions(station, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}